import { Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import {
  addBulkNonCustomMatchingEval,
  addCustomMatchingEval,
  confirmUploadMatching,
  getAppraisal,
  getAppraisalEvals,
} from 'services/api/modules/performance/appraisal/appraisal'
import { useLocation, useNavigate } from 'react-router-dom'
import AddIcon from '@mui/icons-material/Add'
import AdxInfoIcon from 'components/custom/AdxInfoIcon'
import {
  deleteEvaluation,
  getAllEvaluation,
  saveEvaluation,
} from 'services/api/modules/performance/appraisal/evaluation'
import UploadExternalEvaluation from '../../appraisal-cycle-config/view/UploadExternalEvaluation'
import UploadMatching from '../../appraisal-cycle-config/view/UploadMatchingCsv'
import ACNonCustomEvaluationList from '../../appraisal-cycle-config/components/ACNonCustomEvaluationList'
import PreviewEvaluation from '../../appraisal-cycle-config/view/PreviewEvaluation'
import ACPopper from '../../appraisal-cycle-config/components/ACPopper'
import ACNonCustomEvaluation from '../../appraisal-cycle-config/components/ACNonCustomEvaluation'
import ACCustomEvaluation from '../../appraisal-cycle-config/components/ACCustomEvaluation'
import ACCustomEvaluationList from '../../appraisal-cycle-config/components/ACCustomEvaluationList'
import ACMatchingTable from '../../appraisal-cycle-config/components/ACMatchingTable'
import ACExternalEvalTable from '../../appraisal-cycle-config/components/ACExternalEvalTable'
import ManageHeader from '../../manage-appraisal/components/ManageHeader'
import AdxButton from 'components/custom/AdxButton'

const AlManagerEval = () => {
  const navigate = useNavigate()
  const location = useLocation()
  // const [evalPage, setEvalPage] = useState(false)
  const [isModalOpen, setModalOpen] = useState(false)
  const [externalUpload, setExternalUpload] = useState(false)
  const [matchingUpload, setMatchingUpload] = useState(false)
  const [matchingCSVUpload, setMatchingCSVUpload] = useState(false)
  const [preview, setPreview] = useState(false)
  const [selectEvalId, setSelectEvalId] = useState('')

  // Non Custom Mathcing
  const [nonCustomValue, setNonCustomValue] = useState([])
  const [nonCustomEval, setNonCustomEval] = useState([])
  const [nonCustomDisabled, setNonCustomDisabled] = useState([])

  //  Custom Matching
  const [customValue, setCustomValue] = useState([])
  const [customEval, setCustomEval] = useState([])
  const [customDisabled, setCustomDisabled] = useState([])
  const [customMatchingId, setCustomMatchingId] = useState('')
  const [getMatchingData, setGetMatchingData] = useState('')
  const [showMatchingTable, setShowMatchingTable] = useState(false)
  const [completeUploadMatching, setCompleteUploadMatching] = useState(false)
  const [staffData, setStaffData] = useState([])
  const [upload, setUpload] = useState(false)
  const [matchingLoading, setMatchingLoading] = useState(true)

  // External Evaluation
  const [getExternalData, setGetExternalData] = useState([])
  const [completeUploadExternal, setCompleteUploadExternal] = useState(false)
  const [externalCSVUpload, setExternalCSVUpload] = useState(false)
  const [externalLoading, setExternalLoading] = useState(true)

  // API integration
  const queryClient = useQueryClient()

  const test = location.state.appraisalId

  // Create a duplicate eval to upload matching
  const { mutate: addMatchingEval } = useMutation(addCustomMatchingEval, {
    onSuccess: async (response) => {
      setCustomMatchingId(response?.data?.id)
      handleClose()
      setUpload(false)
      // handleAddCustomEval(response?.data)
      setMatchingCSVUpload(true)
      refetchAppraisalData()
      return response?.data
    },
  })

  const { mutate: mutateConfirmUploadMatching } = useMutation(confirmUploadMatching, {
    onSuccess: () => {
      setUpload(false)
      setCompleteUploadMatching(false)
      setMatchingCSVUpload(false)
      refetchAppraisalData()
    },
  })

  const { mutate: deleteMatchingEvaluation } = useMutation(deleteEvaluation, {
    onSuccess: async () => {
      refetchAppraisalData()
    },
    onError: async (error) => {
      // alert(error)
    },
  })

  const { mutate: addNonCustomBulk } = useMutation(addBulkNonCustomMatchingEval, {
    onSuccess: async () => {
      refetchAppraisalData()
    },
  })

  const { mutate: updateMutate } = useMutation(saveEvaluation, {
    onSuccess: () => {
      refetchAppraisalData()
    },
  })

  const { data: getAppraisalEvaluations } = useQuery(['refetchAppraisalEval', test], async () => {
    const { data } = await getAppraisalEvals(test)
    return data
  })

  const { data: allEvalData } = useQuery('allEvalData', async () => {
    const { data } = await getAllEvaluation()
    return data
  })

  const handleOpen = () => {
    setModalOpen(true)
    if (externalUpload || matchingUpload) {
      setExternalUpload(false)
      setMatchingUpload(false)
    }
  }

  const handleClose = () => {
    setModalOpen(false)
    setExternalUpload(false)
    setMatchingUpload(false)

    const nonCustomList = []

    getAppraisalEvaluations?.map((item) => {
      if (item?.matching_id !== 4) nonCustomList.push(item)
    })

    setNonCustomEval(nonCustomList)

    const newCustomDisabled = getAppraisalEvaluations?.map((item) => item)

    setNonCustomDisabled(newCustomDisabled)
    setNonCustomValue([])
  }

  const handleAddExternal = () => {
    setExternalUpload(!externalUpload)
  }

  const handleUploadMatching = () => {
    setMatchingUpload(!matchingUpload)
  }

  const handleOpenPreview = (evalId) => {
    setSelectEvalId(evalId)
    setPreview(!preview)
  }

  const handleClosePreview = () => {
    setPreview(!preview)
  }

  // Non Matching
  const handleNonCustomEval = (event) => {
    let evaluations = nonCustomValue

    const {
      target: { value, checked },
    } = event

    checked ? evaluations.push(+value) : evaluations.splice(evaluations.indexOf(+value), 1)

    setNonCustomValue(evaluations)
    setNonCustomDisabled((nonCustomDisabled) => [...nonCustomDisabled, +value])
  }

  const handleAddNonCustomEval = () => {
    addNonCustomBulk({ appraisalId: test, data: nonCustomValue })
    setNonCustomValue([])
  }

  const handleRemoveNonCustom = (id) => {
    for (let i = 0; i <= nonCustomEval.length; i++) {
      if (nonCustomEval[i]?.id === id) {
        nonCustomEval.splice(i, 1)
        break
      }
    }

    const newNonCustomDisabled = nonCustomDisabled.filter((item) => {
      return item.id !== id
    })

    deleteMatchingEvaluation(id)
    setNonCustomEval(nonCustomEval)
    setNonCustomDisabled(newNonCustomDisabled)
  }

  // Matching
  const handleCustomEval = (event) => {
    let evaluations = customValue

    const {
      target: { value, checked },
    } = event

    checked ? evaluations.push(+value) : evaluations.splice(evaluations.indexOf(+value), 1)

    let createMatchingEval = {
      evaluation_id: +value,
      appraisal_id: test,
    }
    addMatchingEval(createMatchingEval)
    setCustomValue(evaluations)
    setCustomDisabled((customDisabled) => [...customDisabled, +value])
  }

  const handleRemoveCustom = (title, id) => {
    for (let i = 0; i <= customEval.length; i++) {
      if (customEval[i]?.title === title) {
        customEval.splice(i, 1)
        break
      }
    }

    const newCustomDisabled = customDisabled.filter((item) => {
      return item.id !== id
    })

    deleteMatchingEvaluation(id)
    setCustomEval(customEval)
    setCustomDisabled(newCustomDisabled)
  }

  const handleCloseMatchingCSV = () => {
    deleteMatchingEvaluation(customMatchingId)
    setCompleteUploadMatching(false)
    setMatchingCSVUpload(false)
    setUpload(false)
  }

  const refetchAppraisalData = () => {
    queryClient.invalidateQueries('refetchAppraisalEval')
  }

  useEffect(() => {
    const nonCustomList = []
    const customList = []
    getAppraisalEvaluations?.map((item) => {
      item?.matching_id !== 4 ? nonCustomList.push(item) : customList.push(item)
    })

    setNonCustomEval(nonCustomList)
    setCustomEval(customList)

    const newCustomDisabled = getAppraisalEvaluations?.filter((item) => {
      return item
    })

    setCustomDisabled(newCustomDisabled)
    setNonCustomDisabled(newCustomDisabled)
  }, [getAppraisalEvaluations])
  return (
    <>
      {/* Modal to create appraisal */}
      {!preview && (
        <Box
          sx={{
            backgroundColor: 'gray-background.main',
            minHeight: '100vh',
            maxWidth: '100vw',
          }}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          {/* Header */}
          <ManageHeader
            headerTitle="Manage Evaluation"
            handleUpdate={() =>
              navigate(`/app/appraisal-cycle/details/${location.state.id}`, {
                state: { ...location.state, initialTabsValue: 1 },
              })
            }
          />

          {/* Body */}
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            sx={{
              backgroundColor: 'white.main',
              width: '67%',
              borderRadius: '4.5px',
              boxShadow: '0px 0px 10px lightgray',
              p: 3,
              mt: '62px',
            }}
          >
            {/* Add Evaluation*/}
            <Box sx={{ border: 1, borderColor: 'gray-line.main', borderRadius: '4.5px' }}>
              <Box
                display="flex"
                p={2}
                gap={2}
                borderBottom="1px solid"
                borderBottomColor="gray-line.main"
                backgroundColor="gray-background.main"
              >
                <Typography variant="subtitle1" color="light-gray-text.main" width="52%">
                  Evaluation Name
                </Typography>
                <Typography
                  variant="subtitle1"
                  color="light-gray-text.main"
                  sx={{ display: 'flex', justifyContent: 'center', width: '20%' }}
                >
                  Preview Evaluation
                </Typography>
                <Typography
                  variant="subtitle1"
                  color="light-gray-text.main"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '20%',
                    gap: 1,
                    alignItems: 'center',
                  }}
                >
                  Weightage
                  <AdxInfoIcon toolTipTitle="Weightage calculated in value, not %" />
                </Typography>
                <Box width="8%" />
              </Box>
              {nonCustomEval?.map((list) => (
                <ACNonCustomEvaluationList
                  key={list.id}
                  id={list.id}
                  title={list.title}
                  type={list.type}
                  formId={list.form_id}
                  weightage={list.weightage}
                  external={list.is_external === 1 ? true : false}
                  handleOpenPreview={handleOpenPreview}
                  handleRemoveNonCustom={handleRemoveNonCustom}
                  updateMutate={updateMutate}
                />
              ))}
              {customEval?.map((list) => (
                <ACCustomEvaluationList
                  key={list.id}
                  id={list.id}
                  title={list.title}
                  type={list.type}
                  formId={list.form_id}
                  weightage={list.weightage}
                  handleOpenPreview={handleOpenPreview}
                  handleRemoveCustom={handleRemoveCustom}
                  updateMutate={updateMutate}
                />
              ))}
              <ACPopper
                placement="bottom-start"
                sx={{ mt: 1 }}
                placeholder="Add evaluation"
                placeholderColor="alternate.main"
                startIcon={<AddIcon color="alternate" />}
              >
                {location.state.status_name !== 'Scheduled' ? null : (
                  <Box onClick={handleOpen}>Select from existing evaluation</Box>
                )}
                <Box onClick={handleAddExternal}>Upload external evaluation via csv</Box>
                {location.state.status_name !== 'Scheduled' ? null : (
                  <Box onClick={handleUploadMatching}>
                    Upload matching CSV for existing evaluation
                  </Box>
                )}
              </ACPopper>
            </Box>
          </Box>

          {/* Footer */}
          <Box
            display="flex"
            justifyContent="flex-end"
            sx={{
              width: '67%',
              my: '25px',
              gap: 2,
            }}
          ></Box>
        </Box>
      )}

      {/* Modal to show Non Custom Matching evaluation list */}
      <ACNonCustomEvaluation
        isModalOpen={isModalOpen}
        handleClose={handleClose}
        handleNonCustomEval={handleNonCustomEval}
        nonCustomValue={nonCustomValue}
        handleAddNonCustomEval={handleAddNonCustomEval}
        allEvalData={allEvalData}
        nonCustomDisabled={nonCustomDisabled}
      />

      {/* Modal to upload External Evaluation */}
      {externalUpload && (
        <UploadExternalEvaluation
          appraisalId={test}
          setGetExternalData={setGetExternalData}
          completeUploadExternal={completeUploadExternal}
          setCompleteUploadExternal={setCompleteUploadExternal}
          setExternalCSVUpload={setExternalCSVUpload}
          getExternalData={getExternalData}
          refetchAppraisalData={refetchAppraisalData}
          setExternalLoading={setExternalLoading}
        />
      )}

      {/* Modal to show External Evaluation result */}
      {externalCSVUpload && (
        <ACExternalEvalTable
          getExternalData={getExternalData}
          externalCSVUpload={externalCSVUpload}
          setExternalCSVUpload={setExternalCSVUpload}
          setCompleteUploadExternal={setCompleteUploadExternal}
          setGetExternalData={setGetExternalData}
          externalLoading={externalLoading}
        />
      )}

      {/* Modal to show Custom Matching evaluation list */}
      <ACCustomEvaluation
        matchingUpload={matchingUpload}
        handleClose={handleClose}
        handleCustomEval={handleCustomEval}
        customValue={customValue}
        allEvalData={allEvalData}
        customDisabled={customDisabled}
      />

      {/* Modal to upload Matching */}
      {matchingCSVUpload && (
        <UploadMatching
          customMatchingId={customMatchingId}
          handleCloseMatchingCSV={handleCloseMatchingCSV}
          matchingCSVUpload={matchingCSVUpload}
          setShowMatchingTable={setShowMatchingTable}
          setGetMatchingData={setGetMatchingData}
          setCompleteUploadMatching={setCompleteUploadMatching}
          completeUploadMatching={completeUploadMatching}
          staffData={staffData}
          setUpload={setUpload}
          upload={upload}
          mutateConfirmUploadMatching={mutateConfirmUploadMatching}
          setMatchingLoading={setMatchingLoading}
        />
      )}

      {/* Modal to show Matching result */}
      {showMatchingTable && (
        <ACMatchingTable
          getMatchingData={getMatchingData}
          setShowMatchingTable={setShowMatchingTable}
          showMatchingTable={showMatchingTable}
          setCompleteUploadMatching={setCompleteUploadMatching}
          setStaffData={setStaffData}
          staffData={staffData}
          setUpload={setUpload}
          matchingLoading={matchingLoading}
        />
      )}

      {/* Modal to preview Evaluation and Form */}
      {preview && (
        <PreviewEvaluation selectEvalId={selectEvalId} handleClosePreview={handleClosePreview} />
      )}
    </>
  )
}

export default AlManagerEval
